import { useEffect, useCallback } from 'react';

const FavoriteListeners = ({ eventEmitter, applyStoreAction }) => {
    const favoriteCreated = useCallback(favorite => {
        applyStoreAction({
            type: 'FAVORITE_ADD_SOCKET',
            payload: { favorite }
        });
    }, [applyStoreAction]);

    const favoriteEdited = useCallback(favorite => {
        applyStoreAction({
            type: 'FAVORITE_UPDATE_SOCKET',
            payload: {
                favoriteId: favorite.id,
                favorite
            }
        });
    }, [applyStoreAction]);

    const favoriteRemoved = useCallback(({ id }) => {
        applyStoreAction({
            type: 'FAVORITE_REMOVE_SOCKET',
            payload: { favoriteId: id }
        });
    }, [applyStoreAction]);

    const listen = () => {
        eventEmitter.on('favorite_created', favoriteCreated);
        eventEmitter.on('favorite_updated', favoriteEdited);
        eventEmitter.on('favorite_removed', favoriteRemoved);

        return () => {
            eventEmitter.off('favorite_created', favoriteCreated);
            eventEmitter.off('favorite_updated', favoriteEdited);
            eventEmitter.off('favorite_removed', favoriteRemoved);
        };
    };

    useEffect(listen, [eventEmitter, favoriteCreated, favoriteEdited, favoriteRemoved]);

    return null;
}

export default FavoriteListeners;
